module.exports = __webpack_public_path__ + "static/img/アセット 18@2x.66670a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 18@2x.png
// module id = SSje
// module chunks = 1